module.exports = __webpack_public_path__ + "media/images/icons/cbi3-f6b0af9f60389ab3c456be0dd4b71106.svg";